import { render, staticRenderFns } from "./PunchCard.vue?vue&type=template&id=ed821f86&scoped=true&"
import script from "./PunchCard.vue?vue&type=script&lang=js&"
export * from "./PunchCard.vue?vue&type=script&lang=js&"
import style0 from "./PunchCard.vue?vue&type=style&index=0&id=ed821f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed821f86",
  null
  
)

export default component.exports